export function getParentPath(path: string) {
  return (
    path.substring(
      0,
      path.lastIndexOf("/", path.endsWith("/") ? path.length - 2 : undefined)
    ) || "/"
  );
}
